// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609160934/js/" + chunkId + "." + {"44":"81ac2182","225":"d2042b06","481":"3f41155b","486":"ae8c2b44","770":"391a229e"}[chunkId] + ".0.5174021943705549.chunk.js";
};